/* import __COLOCATED_TEMPLATE__ from './siret-banner.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { GetSiretBannerStatusResponse } from '@square/dashboard-protos/models/squareup/spos/siret-banner/api';
const BannerDisplayPropertyMap = {
  [GetSiretBannerStatusResponse.BannerType.SIRET_OPTIONAL]: {
    variant: 'warning',
    contentText: ({
      i18n
    }) => i18n.t('onboard.frSiretOptional.siretOptional'),
    linkText: ({
      i18n
    }) => i18n.t('onboard.frSiretOptional.submitSiret'),
    linkHref: () => '/signup/fr?v=provide-siret'
  },
  [GetSiretBannerStatusResponse.BannerType.SIRET_REQUIRED]: {
    variant: 'critical',
    contentText: ({
      i18n
    }) => i18n.t('onboard.frSiretOptional.siretRequired'),
    linkText: ({
      i18n
    }) => i18n.t('onboard.frSiretOptional.submitSiret'),
    linkHref: () => '/signup/fr?v=provide-siret'
  }
};
/**
 * This component renders a response retrieved from the SiretBannerService.GetSiretBannerStatus
 * API.
 *
 * It is currently used for:
 * Siret Optional experiment
 */
let SiretBanner = (_class = class SiretBanner extends Component {
  get bannerType() {
    return this.args.getSiretBannerStatusResponse?.type;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "formatter", _descriptor2, this);
    _initializerDefineProperty(this, "localeTime", _descriptor3, this);
    _initializerDefineProperty(this, "modal", _descriptor4, this);
    _initializerDefineProperty(this, "userInfo", _descriptor5, this);
    _initializerDefineProperty(this, "variant", _descriptor6, this);
    _initializerDefineProperty(this, "contentText", _descriptor7, this);
    _initializerDefineProperty(this, "linkText", _descriptor8, this);
    _initializerDefineProperty(this, "linkHref", _descriptor9, this);
    // eslint-disable-next-line no-use-before-define
    _initializerDefineProperty(this, "linkHandler", _descriptor10, this);
    const bannerType = this.args.getSiretBannerStatusResponse?.type;
    if (!bannerType || BannerDisplayPropertyMap[bannerType] === undefined) {
      return;
    }
    const bannerDisplayProperties = BannerDisplayPropertyMap[bannerType];
    this.contentText = bannerDisplayProperties?.contentText({
      getSiretBannerStatusResponse: this.args.getSiretBannerStatusResponse,
      formatter: this.formatter,
      i18n: this.i18n,
      localeTime: this.localeTime
    });
    this.variant = bannerDisplayProperties?.variant;
    this.linkText = bannerDisplayProperties?.linkText({
      i18n: this.i18n
    });
    this.linkHref = bannerDisplayProperties?.linkHref?.({
      userInfo: this.userInfo
    });
  }
  onLinkClick() {
    if (this.linkHandler) {
      this.linkHandler(this);
    }
  }
  async openPaymentMethodModal() {
    // eslint-disable-next-line dashboard/require-modal-open-component
    await this.modal.open('subscriptions/update-payment-method-modal', {
      unitToken: this.userInfo.mainUnitToken
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "localeTime", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "variant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "contentText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "linkText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "linkHref", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "linkHandler", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return async () => {
      // No-op. Event is propagated.
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "onLinkClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onLinkClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openPaymentMethodModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openPaymentMethodModal"), _class.prototype), _class);
export { SiretBanner as default };